import { render, staticRenderFns } from "./AdminMessage.vue?vue&type=template&id=78a456e3&scoped=true&"
import script from "./AdminMessage.vue?vue&type=script&lang=js&"
export * from "./AdminMessage.vue?vue&type=script&lang=js&"
import style0 from "./AdminMessage.vue?vue&type=style&index=0&id=78a456e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a456e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VDataTable,VDialog,VIcon,VRow})
